import { render, staticRenderFns } from "./generalModal.vue?vue&type=template&id=5ec83b44"
import script from "./generalModal.vue?vue&type=script&lang=js"
export * from "./generalModal.vue?vue&type=script&lang=js"
import style0 from "./generalModal.vue?vue&type=style&index=0&id=5ec83b44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports